// Real-time -> sim-tick conversion. Lives outside GameState: speed and pause are
// session settings, not world state.

import { TUNABLES } from "@degen/shared/config/tunables";

export type Speed = (typeof TUNABLES.clock.speeds)[number];

export class Clock {
  speed: Speed = 1;
  /** Reasons the sim is held paused (onboarding, modal, rekt screen...). */
  private holds = new Set<string>();
  private acc = 0;

  get ticksPerSecond(): number {
    return TUNABLES.clock.ticksPerDay / TUNABLES.clock.realSecondsPerDay;
  }

  get paused(): boolean {
    return this.speed === 0 || this.holds.size > 0;
  }

  hold(reason: string) {
    this.holds.add(reason);
  }

  release(reason: string) {
    this.holds.delete(reason);
  }

  /** Advance real time; returns how many whole ticks the sim should run now. */
  update(dtSeconds: number): number {
    if (this.paused || !(dtSeconds > 0)) return 0;
    this.acc += dtSeconds * this.ticksPerSecond * this.speed;
    const ticks = Math.floor(this.acc);
    this.acc -= ticks;
    const max = TUNABLES.clock.maxTicksPerFrame;
    if (ticks > max) {
      this.acc = 0; // drop the backlog instead of spiralling
      return max;
    }
    return ticks;
  }
}
